<style lang="scss">
  .widget {
    width: 100%;
    padding: 10px 17px;
    color: #73879C;
    background: #fff;
    border: 1px solid #E6E9ED;
    opacity: 1;
    transition: all .2s ease;
    .body {
      transition: all .2s ease;
    }
    &-header {
      border-bottom: 2px solid #E6E9ED;
      padding: 1px 5px 6px;
      .title {
        padding: 5px 5px 7px;
        float: left;
        h3 {
          margin: 0;
          font-weight: 400;
        }
      }
    }
    ul.tool-btn {
      padding: 5px 5px 7px;
      margin: 0;
      list-style: none;
      float: right;
      li {
        float: left;
        a {
          padding: 5px;
          color: #C5C7CB;
          font-size: 14px;
          cursor: pointer;
          &:hover {
            background: #F5F7FA;
          }
        }
      }
    }
  }
</style>
<template>
  <div class="widget">
    <div class="widget-header clearfix" v-if="!$slots.header">
      <div class="title">
        <h3>{{title}}</h3>
      </div>
      <ul class="tool-btn">
        <li>
          <a @click="collapsed=!collapsed">
            <i class="fa " :class ="{
              'fa-chevron-up': !collapsed,
              'fa-chevron-down': collapsed,
              }"></i>
          </a>
        </li>
        <li>
            <a @click="close">
              <i class="fa fa-close"></i>
            </a>
        </li>
      </ul>
    </div>
    <div class="widget-header" v-if="$slots.header">
      <slot name="header"></slot>
    </div>
    <div class="body" v-show="!collapsed">
       <slot></slot>
    </div>
    <div class="footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'zk-widget',
    data () {
      return {
        collapsed: false
      }
    },
    props: {
      title: {
        type: String,
        default: ''
      }
    },
    methods: {
      close () {
        this.$destroy()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Widget.vue?a0e65bdc